<template>
	<v-container fluid>
		<!--		<v-row class="ma-0">-->
		<!--			<v-col cols="12">-->
		<!--				<v-row class="ma-0">-->
		<!--					<mortality-control-filters-dialog-->
		<!--						@apply="listMortalityControl"-->
		<!--					>-->
		<!--						<template v-slot:activator="{ on }">-->
		<!--							<v-btn v-on="on" color="info">-->
		<!--								<v-icon left>mdi-magnify</v-icon>-->
		<!--								Filtros-->
		<!--							</v-btn>-->
		<!--						</template>-->
		<!--					</mortality-control-filters-dialog>-->
		<!--				</v-row>-->
		<!--			</v-col>-->
		<!--		</v-row>-->
		<v-row justify="center" class="ma-0">
			<v-card style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;">
				<v-card-title>
					<v-row class="ma-0">
						<span>Controle Sanitário de Mortalidade</span>
					</v-row>
				</v-card-title>
        <v-divider/>
				<v-card-text>
					<v-container fluid>
						<v-row>
							<!-- Table -->
							<v-col cols="12" xl="12">
								<mortality-control-filters
									@apply="listMortalityControl"
									@clear="clearData"
								/>
							</v-col>
							<v-col cols="12" xl="12">
                <v-subheader>Tabela</v-subheader>
								<v-data-table
									:headers="tableHeaders"
									:items="items"
									:loading="loading"
    								item-key="idLoteProducao"
                  					:calculate-widths="true"
									@click:row="goToLote"
								>
									<template v-slot:item.dsOrigensLimitado="{ item }">
										<v-tooltip bottom>
											<template v-slot:activator="{ on }">
												<v-chip style="background: #e0e0e000;" v-on="on">{{ item.dsOrigensLimitado }}</v-chip>
											</template>
											<span> {{ item.dsOrigens }}</span>
										</v-tooltip>
									</template>
									<template
										v-slot:item.dtAlojamento="{ value }"
									>
										{{ value | formatDate }}
									</template>
									<template v-slot:item.color="{ item }">
										<v-row
											class="fill-height"
											:class="
												alertColorClass(
													item['nrLimite'],
													item['nrIndiceMorte']
												)
											"
										/>
									</template>
								</v-data-table>
							</v-col>
							<!-- Chart -->
							<v-col cols="12" xl="12">
                <v-subheader>Gráfico</v-subheader>
								<apexchart
									type="line"
									:options="chartOptions"
									:series="chartSeries"
								/>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
			</v-card>
		</v-row>
	</v-container>
</template>

<script>
import apexchart from 'vue-apexcharts';
import { URLS } from '@/modules/MortalityControl/api/urls';
import moment from 'moment';
import MortalityControlFilters from '@/modules/MortalityControl/components/MortalityControlFilters';

export default {
	name: 'MortalityControl',
	components: { MortalityControlFilters, apexchart },
	data: () => ({
		items: [],
		loading: false,
		expanded: [],
        singleExpand: false,
	}),
	computed: {
		tableHeaders() {
			return [
				{
					text: 'Tipo',
					value: 'csTipoUnidade',
          			align: "start"
				},
				{
					text: 'Produtor',
					value: 'nmProdutor',
          			align: "start"
				},
				{
					text: 'Pavilhão',
					value: 'nrPavilhao',
          			align: "start"
				},
				{
					text: 'Data de Alojamento',
					value: 'dtAlojamento',
          			align: "start"
				},
				{
					text: 'Dias Alojados',
					value: 'nrDiasAlojado',
          			align: "start"
				},
				{
					text: 'Limite',
					value: 'nrLimite',
          			align: "start"
				},
				{
					text: 'Percentual de mortalidade',
					value: 'nrIndiceMorte',
		  			align: "start"
				},
				{ text: '', value: 'data-table-expand' },
				{
					text: 'Origens',
					value: 'dsOrigensLimitado',
          			align: "start"
				},
				{
					text: '',
					value: 'color'
				},
			];
		},
		sortedReducedItemsByAccommodation() {
			const items = this.reducedItemsByAccommodation;
			if (!items) return [];
			if (items.length <= 0) return [];
			return Object.keys(items)
				.sort((a, b) => a - b)
				.map(key => {
					const groupedItems = items[key];
					const avgLimit = (
						groupedItems.reduce(
							(acc, curr) => (acc += curr.nrLimite),
							0
						) / groupedItems.length
					).toFixed(2);
					const avgMortalityPerc = (
						groupedItems.reduce(
							(acc, curr) => (acc += curr.nrIndiceMorte),
							0
						) / groupedItems.length
					).toFixed(2);
					return {
						nrLimite: avgLimit,
						nrIndiceMorte: avgMortalityPerc
					};
				});
		},
		reducedItemsByAccommodation() {
			const items = this.items;
			if (!items) return [];
			if (items.length <= 0) return [];

			return items.reduce((acc, curr) => {
				if (!acc[parseInt(curr.nrDiasAlojado)])
					acc[parseInt(curr.nrDiasAlojado)] = [];
				acc[parseInt(curr.nrDiasAlojado)].push(curr);
				return acc;
			}, {});
		},
		chartOptions() {
			return {
				chart: {
					stacked: false
				},
				xaxis: {
					categories: this.chartXAxis,
					title: {
						text: 'Dias de alojamento'
					}
				},
				tooltip: {
					marker: {
						show: false
					}
				},
				markers: {
					size: 5
				},
				colors: ['#2196F3', '#ff5429']
			};
		},
		chartSeries() {
			return [this.metaSeries, this.percMortalityIndexSeries];
		},
		chartXAxis() {
			return Object.keys(this.reducedItemsByAccommodation).sort(
				(a, b) => a - b
			);
		},
		metaSeries() {
			const data = this.sortedReducedItemsByAccommodation.map(
				item => item.nrLimite
			);
			return {
				name: 'Limite',
				data: data
			};
		},
		percMortalityIndexSeries() {
			const data = this.sortedReducedItemsByAccommodation.map(
				item => item.nrIndiceMorte
			);
			return {
				name: 'Percentual de mortalidade',
				data: data
			};
		}
	},
	filters: {
		formatDate(value) {
			const parsedDate = moment(value);
			if (!parsedDate.isValid()) return '';
			return parsedDate.format('DD/MM/YYYY');
		}
	},
	methods: {
		goToLote(item) {
			this.$router.push({name: 'loteProducao', params: {id: item.idLoteProducao}})
		},
		alertColorClass(meta, percMortalityIndex) {
			const breakpointValue = meta * 1.1;
			if (percMortalityIndex < meta) return 'success';
			else if (percMortalityIndex <= breakpointValue) return 'warning';
			else return 'error';
		},
		async listMortalityControl(queryParams = null) {
			this.loading = true;

			const response = await this.$axios
				.get(URLS.MORTALITY_CONTROL, {
					params: queryParams
				})
				.finally(() => (this.loading = false));

			if (response.status === 200) {
				if (response.data.length > 0) {
					const data = response.data[0].data.map(v => ({
						...v,
                        dsOrigensLimitado: v.dsOrigens.length > 20 ? v.dsOrigens.substring(0, 20) + '...' : v.dsOrigens
					}));

					if (data) this.items = data;
					else this.items = [];
				}
			}
		},
		clearData() {
			this.items = []
		}
	}
};
</script>

<style scoped></style>
